import DataStore from '../dao/DataStore';
import cookie from 'js-cookie';

const app = {
    state: {
        vipFlag: false
    },
    mutations: {
        UPDTE_VIP_FLAG(state,val) {
            state.vipFlag = val;
        },
    },
    actions: {
        update_vip_flag({ commit },val) {
            commit('UPDTE_VIP_FLAG',val);
        },
    }
};

export default app;



// WEBPACK FOOTER //
// ./src/store/app.js